import './index.css';
import React from 'react';
import ReactDOM from 'react-dom';
import TableAnimation from '../Animations/TableAnimation';

const Loader = ({ message }) =>
    ReactDOM.createPortal(
        <div className='loading-spiner-call'>
            <div className='loading'>
                <div className='loading-content'>
                    <TableAnimation />
                    {message && <p>{message}</p>}
                </div>
            </div>
        </div>,
        document.body
    )

export default Loader;
